import * as yup from 'yup';

const accommodationMarketingSchema = yup.object().shape({
  name: yup.string().required('common.required'),
  type: yup.object().shape({
    value: yup.string(),
    label: yup.string(),
  }).nullable().required('common.required'),
  features: yup.array().of(yup.object().shape({
    value: yup.string(),
    label: yup.string(),
  })),
  capacity: yup.number().required('common.required'),
  size: yup.number().min(1, 'common.errors.needMoreThanZero').required('common.required'),
  spec: yup.object().shape({
    value: yup.string(),
    label: yup.string(),
  }).nullable().required('common.required'),
  checkInFromHour: yup.object().shape({
    value: yup.string(),
    label: yup.string(),
  }).nullable().required('common.required'),
  checkOutUntilHour: yup.object().shape({
    value: yup.string(),
    label: yup.string(),
  }).nullable().required('common.required'),
  isBreakfastIncluded: yup.bool(),
  mainImageMedia: yup.object().shape({
    id: yup.string(),
    fileId: yup.string(),
  }).nullable().required('common.required'),
  sliderImageMedias: yup.array().of(yup.object().shape({
    id: yup.string(),
    fileId: yup.string(),
  })).nullable().min(3, 'common.minThree'),
});

export default accommodationMarketingSchema;
